import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { ClaimService } from "../claims-view/claim.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import swal from "sweetalert2";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "app-all-claims",
  templateUrl: "./all-claims.component.html",
  styleUrls: ["./all-claims.component.scss"],
})
export class AllClaimsComponent implements OnInit {
  claims;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  expandedElement: any;
  current_item;
  current_payments;
  add_claim = {
    date: null,
    due_date: null,
    title: "",
    description: "",
    user_id: null,
  };
  accountants: any;
  current_payment: any;
  cancel_invoice = {
    reason: "",
  };
  payments_for_add;
  current_page = 1;
  projects;

  @ViewChild("topScroll") topScroll: ElementRef;
  @ViewChild("tableScroll") tableScroll: ElementRef;

  active_tab: any = "filter";
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;
  is_refreshing = false;
  pageTest = 1;
  itemSub: Subscription;

  constructor(
    private reservationService: ReservationService,
    private claimService: ClaimService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    private route: ActivatedRoute,
    private slimLoadingBarService: SlimLoadingBarService,
    private leadsService: LeadsService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.createForms();
    this.getClaimsTab();
    this.getAgents();
    this.getProjects();
  }

  createForms() {
    this.filterForm = this.fb.group({
      serial: [""],
      status: [""],
      over_due: [""],
      user_id: [""],
      project_id: [""],
      cheque_number: [""],
      cheque_date: [""],
    });
  }

  getProjects() {
    this.reservationService.getProjectsSelection().subscribe(
      (res: any) => {
        this.projects = res;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  setFilterActiveTab() {
    if (this.active_tab == "" || this.active_tab == "sales-status") {
      this.active_tab = "filter";
    } else {
      this.active_tab = "";
    }
  }

  getAgents() {
    this.accountants = null;
    this.claimService.getAccountants().subscribe(
      (data: any) => {
        this.accountants = data;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  makeTableScrollable() {
    setTimeout(() => {
      //console.log(this.topScroll, this.tableScroll);

      // Synchronize scroll between the top scrollbar and the actual table
      this.topScroll.nativeElement.addEventListener("scroll", () => {
        this.tableScroll.nativeElement.scrollLeft =
          this.topScroll.nativeElement.scrollLeft;
      });

      this.tableScroll.nativeElement.addEventListener("scroll", () => {
        this.topScroll.nativeElement.scrollLeft =
          this.tableScroll.nativeElement.scrollLeft;
      });
    }, 1000);
  }

  getClaimsTab(filters = {}) {
    this.slimLoadingBarService.start();
    this.claimService.getAllClaims(filters).subscribe(
      (res: any) => {
        this.current_page = res.current_page;
        this.claims = {
          ...res,
          data: res.data.map((claim) => ({
            ...claim,
            rowSelected: false,
          })),
        };
        setTimeout(() => {
          this.makeTableScrollable();
        }, 2000);
        this.slimLoadingBarService.complete();
        //console.log(this.claims);
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getClaimsSelected(filterFunction = () => true) {
    const selectedClaims = this.claims.data
      .filter((payment) => payment.rowSelected)
      .filter(filterFunction);
    const payments = [];
    selectedClaims.forEach((claim) => {
      payments.push(...claim.payments);
    });
    return payments;
  }

  selectAllClaims(value) {
    this.claims.data.forEach((payment) => {
      payment.rowSelected = value;
    });
  }

  toggleRow(item: any): void {
    // this.expandedElement = this.expandedElement === item ? null : item;
    if (item.is_expanded) {
      this.expandedElement = null;
      item.is_expanded = false;
      return;
    }
    if (this.itemSub) {
      this.itemSub.unsubscribe();
      this.claims.data.forEach((payment) => {
        payment.is_expanded = false;
        payment.loading = false;
      });
    }
    item.loading = true;
    this.slimLoadingBarService.start();
    this.itemSub = this.claimService
      .getItemDetails(item.id)
      .subscribe((res: any) => {
        item.loading = false;
        this.slimLoadingBarService.complete();
        item.payments = res.payments;
        this.expandedElement = this.expandedElement === item ? null : item;
        item.is_expanded = true;
      });
  }

  deleteDemand(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete it!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.claimService.deletePayment(id).subscribe(
          (data) => {
            swal("Done!", "Deleted successfully!", "success");
            this.getClaimsTab();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
      }
    });
  }

  viewETAClaims(item) {
    this.router.navigateByUrl(
      `/pages/financial/claims/${item.reservation.id}/eta-view/${item.id}`
    );
  }

  sendClaimsToSelectedETA(item) {
    const payload = {
      reservation_id: item.reservation.id,
      demand_id: item.id,
    };
    //console.log(payload);
    this.reservationService.sendToETA(payload).subscribe(
      (res: any) => {
        swal("Success", "Payments sent to ETA", "success");
        this.getClaimsTab();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  approveClaims(item) {
    const payload = {
      reservation_id: item.reservation.id,
      ids: [item.id],
      status: "approve",
    };
    this.reservationService.approveClaims(payload).subscribe(
      (res: any) => {
        swal("Success", "Claims Approved", "success");
        this.getClaimsTab();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  rejectClaims(item) {
    const payload = {
      reservation_id: item.reservation.id,
      ids: [item.id],
      status: "reject",
    };
    this.reservationService.approveClaims(payload).subscribe(
      (res: any) => {
        swal("Success", "Claims rejected", "success");
        this.getClaimsTab();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  assignClaimsModalOpen(current_item, modal) {
    this.current_item = current_item;
    //console.log(this.current_item);
    modal.open();
  }

  assignClaimModal(modal) {
    //console.log(this.current_payments);
    let payload = {
      reservation_id: this.current_item.reservation.id,
      user_id: this.add_claim.user_id,
      ids: [this.current_item.id],
    };
    this.slimLoadingBarService.start();
    this.claimService.assignClaim(payload).subscribe(
      (res) => {
        this.slimLoadingBarService.complete();
        swal("Success", "Claims Assigned", "success");
        modal.close();
        this.getClaimsTab();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  makeCreditNote(item, payment) {
    //console.log(item.reservation.id);
    this.slimLoadingBarService.start();
    const payload = {
      id: payment.id,
      type: payment.type,
      reservation_id: item.reservation.id,
    };
    this.reservationService.makeCreditNote(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.getClaimsTab();
        swal("Woohoo!", "Credit Note created succesfully!", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  openCancelInvoiceModal(payment, cancelInvoiceModal) {
    this.current_payment = payment;
    cancelInvoiceModal.open();
  }

  submitCancelInvoice(cancelInvoiceModal) {
    const payload = {
      ...this.cancel_invoice,
      id: this.current_payment.id,
      type: this.current_payment.type,
    };
    this.slimLoadingBarService.start();
    this.reservationService.cancelInvoice(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        cancelInvoiceModal.close();
        this.getClaimsTab();
        swal("Woohoo!", "Cancel Invoice created succesfully!", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  deleteClaim(item, ids) {
    let payload = {
      ids: Array.isArray(ids) ? ids : [ids],
    };
    this.claimService.deleteClaim(item.reservation.id, payload).subscribe(
      (res: any) => {
        this.getClaimsTab();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  pageChange(event) {
    if (event) {
      let arr = this.claims.last_page_url.split("?");
      let selectedUrl = `${arr[0]}?page=${event}`;
      this.infinite(selectedUrl, event);
    }
  }

  infinite(url, number) {
    this.slimLoadingBarService.start();
    this.leadsService.infinit(url).subscribe(
      (data: any) => {
        this.claims = data;
        this.current_page = number;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  filterAllClaims() {
    const filters = this.filterForm.value;
    this.getClaimsTab(filters);
  }

  resetFilters() {
    const filters = {};
    this.filterForm.reset();
    this.getClaimsTab(filters);
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/all-claims/all-claims.component.ts